import React from 'react';
import { useIntl } from 'umi';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';
import classNames from 'classnames';
import './index.scss';
interface INoData{
  text : string;
  className: string;
}
const NoData = (props: INoData) => {
  const {formatMessage } = useIntl();
  const { text = formatMessage({ id: 'common_nodata'}), className} = props;
  return <FormatHtmlTextToReact className={classNames("no-data",className)} text={text} />;
  
};

export default NoData;
